const extractCount = /_(\d+)/;

export function getUniquePropertyString(obj: any, propertyName: string): string {
    let originalPropertyName = propertyName;
    while (obj[propertyName] != undefined) {
        let matches = propertyName.match(extractCount);
        let num = 1;
        if (matches && matches[1]) {
            num = parseInt(matches[1]) + 1;
        }
        propertyName = originalPropertyName + '_' + num;
    }

    return propertyName;
}
